/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, Input, InputSignal, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SendUpdateRouteService } from '../send-update-route.service';

@Component({
  selector: 'cicerone-list-pdf',
  standalone: true,
  imports: [CommonModule, TranslateModule, SharedModule],
  templateUrl: './list-pdf.component.html',
  styleUrls: ['./list-pdf.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ListPdfComponent {
  public pdfs: InputSignal<any> = input.required<any>();
  private sendUpdateService = inject(SendUpdateRouteService)
  public pdfsSelectedIds = computed(() => this.sendUpdateService.userData()?.pdfs || [])

  removePdf(pdfId){
    this.sendUpdateService.removePdf(pdfId)
  }

  toggleView(){
    this.sendUpdateService.toggleView();
  }

}
